import { z } from 'zod'
import { MarinaSchema } from './marina'

export const LoginFormSchema = z
  .object({
    username: z.string().min(3, 'Username must be at least 3 characters'),
    password: z.string().min(6, 'Password must be at least 6 characters'),
  })
  .strict()

export const emptyLoginSchema: LoginForm = {
  username: '',
  password: '',
}

export const UserSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  marinas: z.array(MarinaSchema),
})

export type LoginForm = z.infer<typeof LoginFormSchema>
export type UserData = z.infer<typeof UserSchema>
